<template>
  <div>
    <div
      class="onboarding-modal modal fade animated"
      id="modalClonarProducto"
      role="dialog"
      tabindex="-1"
      style="display: none;"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            ref="cerrarModalClonar"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content with-gradient">
            <h4 class="onboarding-title">
              Cambiar Presentación
            </h4>
            <div class="onboarding-text"></div>
            <form @submit="clonar">
              <div class="row">
                <div class="col-sm-12">
                  <ul class="features-list">
                    <li>
                      El cambio de presentación del producto tomará toda la información no
                      transaccional y creará una copia con el nuevo
                      código elegido por el usuario.
                    </li>
                    <li>
                      No se incluirán transacciones anteriores, se debe elegir entre las
                      opciones que se requiere cambiar.
                    </li>
                    <li>
                      Tomar en cuenta que los productos no deben poseer el mismo código
                      de barra, ya que podría generar un error en la facturación de dicho
                      producto.
                    </li>
                    <li>
                      Se recomienda desactivar el producto anterior si es un
                      cambio de código.
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="">Nuevo Código</label>
                    <input
                      class="form-control text-center"
                      placeholder="Nuevo Código"
                      type="text"
                      v-model="parametros.nuevo_sku"
                      required
                      value=""
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        disabled
                        v-model="parametros.incluir_barras"
                        class="form-check-input"
                      />Clonar Barras
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked="checked"
                        type="checkbox"
                        v-model="parametros.incluir_precios"
                        class="form-check-input"
                      />Clonar Precios
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked="checked"
                        type="checkbox"
                        v-model="parametros.incluir_proveedores"
                        class="form-check-input"
                      />Clonar Proveedores
                    </label>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked="checked"
                        type="checkbox"
                        v-model="parametros.incluir_medidas"
                        class="form-check-input"
                      />Clonar Unidades de Medidas
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked="checked"
                        type="checkbox"
                        v-model="parametros.incluir_min_max"
                        class="form-check-input"
                      />Clonar Mínimos y Máximos
                    </label>
                  </div>
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        checked="checked"
                        type="checkbox"
                        v-model="parametros.desactivar_el_actual"
                        class="form-check-input"
                      />Desactivar el Producto Actual
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-buttons-w">
                <button type="submit" class="btn btn-primary btn-block">
                  Confirmar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  data() {
    return {
      parametros: {
        nuevo_sku: null,
        incluir_barras: false,
        incluir_precios: false,
        incluir_proveedores: false,
        incluir_medidas: false,
        incluir_imagenes: false,
        incluir_min_max: false,
        desactivar_el_actual: false,
      },
    };
  },
  props: ["producto"],
  watch: {},
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    clonar: function(e) {
      e.preventDefault();
      let self = this;
      Notifications.alert.confirm(
        "Cambio de Presentación",
        "La información ingresada es correcta?",
        "Si",
        function() {
          DynamicService.postAction(
            "cat",
            "productos",
            self.producto.sku,
            "crear_producto_relacionado",
            self.parametros
          )
            .then((response) => {
              self.$router.push({
                name: "cat-productos-editar",
                params: { sku: self.parametros.nuevo_sku },
              });
              self.$refs.cerrarModalClonar.click();
              self.$emit("cerrandomodal");
              Notifications.alert.success(
                "Cambio de Presentación",
                "Se a cambiado la presentación del producto"
              );
            })
            .catch((error) => {
              console.log(error.response.data)
              Notifications.alert.error(
                "Cambio de Presentación",
                error.response.data.nuevo_sku[0]
              );
            });
        }
      );
    },
  },
};
</script>
